import { EhrAppointmentKind } from '@src/types'

export const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null

export const getString = (source: Record<string, unknown>, key: string) =>
  typeof source[key] === 'string' ? source[key] : ''

export const getOptionalString = (source: Record<string, unknown>, key: string) => {
  const value = getString(source, key)

  return value.trim() ? value : undefined
}

export const getNumber = (source: Record<string, unknown>, key: string) =>
  typeof source[key] === 'number' ? source[key] : null

export const getAppointmentKind = (draft: Record<string, unknown>): EhrAppointmentKind | null => {
  const value = getString(draft, 'appointment_kind')

  return Object.values(EhrAppointmentKind).includes(value as EhrAppointmentKind)
    ? (value as EhrAppointmentKind)
    : null
}
